import "./App.css";
import "./style/css/reset.css";
import "./style/css/sidebar.css";
import "./style/css/style.css";
import "./style/css/zone.css";
import "./style/css/filmroom_style.css";
import { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
// import Login from './Pages/Login';
// import MainPage from './Pages/MainPage';
/// import Filter from './Pages/Filter';
// import LeaderBoard from './Pages/LeaderBoard';
// import TeamLeaderBoard from './Pages/TeamLeaderBoard';
// import Roster from './Pages/Roster';
// import PersonBatter from './Pages/PersonBatter';
// import PersonPitcher from './Pages/PersonPitcher';
// import { useEffect } from 'react';
// import { PitchReport } from './Pages/PitcherReport';
// import jwtDecode from 'jwt-decode';
import { ProtectedRoute } from "./Components/ProtectedRoute";
// import { PAReport } from './Pages/PAReport';
// import { TeamsMainPage } from './Pages/TeamsMainPage';
// import Catchers from './Pages/Catchers';
// import { VideoStreamer } from './Pages/VideoStreamer';
// import VideoList from './Pages/VideoList';
// import HeadToHead from './Pages/HeadToHead';
// import UmpireReport from './Pages/UmpireReport';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Loading from "./Components/Loading";
import SingleGameReport from "./Pages/SingleGameReport";
import Filmroom from "./Pages/Filmroom";
// import Search from './Pages/Search';
// import EVLeaderBoard from './Pages/EVLeaderBoard';
// import DisciplineLeaderBoard from './Pages/DisciplineLeaderBoard';
// import InTimeGameReport from './Pages/InTimeGameReport';
// import Location from './Pages/Location';

export const OpenindDayDate = new Date(2022, 3, 3);

const Login = lazy(() => import("./Pages/Login"));
const Filter = lazy(() => import("./Pages/Filter"));
const LeaderBoard = lazy(() => import("./Pages/LeaderBoard"));
const TeamLeaderBoard = lazy(() => import("./Pages/TeamLeaderBoard"));
const Roster = lazy(() => import("./Pages/Roster"));
const PersonBatter = lazy(() => import("./Pages/PersonBatter"));
const PersonPitcher = lazy(() => import("./Pages/PersonPitcher"));
const Catchers = lazy(() => import("./Pages/Catchers"));
const VideoStreamer = lazy(() => import("./Pages/VideoStreamer"));
const VideoList = lazy(() => import("./Pages/VideoList"));
const HeadToHead = lazy(() => import("./Pages/HeadToHead"));
const UmpireReport = lazy(() => import("./Pages/UmpireReport"));
const Search = lazy(() => import("./Pages/Search"));
const EVLeaderBoard = lazy(() => import("./Pages/EVLeaderBoard"));
const DisciplineLeaderBoard = lazy(
  () => import("./Pages/DisciplineLeaderBoard"),
);
const InTimeGameReport = lazy(() => import("./Pages/InTimeGameReport"));
const GeneralGameReport = lazy(() => import("./Pages/GeneralGameReport"));

const App = () => {
  // const handleGoogleCallbaclResponse = (response) => {
  //   console.log(jwtDecode(response.credential))
  //   console.log("Successfully get Google login info!")
  // }

  /* Not ready for google login
  useEffect(() => {
    // /* global google (back star need to be added when use)
    google.accounts.id.initialize({
      client_id: process.env.REACT_APP_GOOGLE_TEST_API_CLIENT_ID,
      callback: handleGoogleCallbaclResponse
    })
    // console.log(google.accounts.id)
    google.accounts.id.renderButton(document.getElementById('google-login-btn'), {theme: 'filled_blue', size: 'large', shape: 'pill', width: 210, text: 'signin_with'})
  });
  */

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <div className="App">
        <Suspense fallback={<Loading visible={true} />}>
          <Routes>
            <Route
              path="/filter"
              element={<ProtectedRoute element={<Filter />} />}
            />
            <Route
              path="/leaderboard"
              element={<ProtectedRoute element={<LeaderBoard />} />}
            />
            <Route
              path="/team-leaderboard"
              element={<ProtectedRoute element={<TeamLeaderBoard />} />}
            />
            <Route
              path="/roster"
              element={<ProtectedRoute element={<Roster />} />}
            />
            <Route
              path="/batter/:team/:number"
              element={<ProtectedRoute element={<PersonBatter />} />}
            />
            <Route
              path="/pitcher/:team/:number"
              element={<ProtectedRoute element={<PersonPitcher />} />}
            />
            {/* <Route path='/teams/:type' element={<ProtectedRoute element={<TeamsMainPage />} />} /> */}
            <Route
              path="/search"
              element={<ProtectedRoute element={<Search />} />}
            />
            <Route
              path="/catchers"
              element={<ProtectedRoute element={<Catchers />} />}
            />
            <Route
              path="/video/:year/:gameNo"
              element={<ProtectedRoute element={<VideoStreamer />} />}
            />
            <Route
              path="/play-by-play-video/:year/:gameNo/:plateId"
              element={
                <ProtectedRoute
                  element={<VideoStreamer mode="play-by-play" />}
                />
              }
            />
            <Route
              path="/video-list"
              element={<ProtectedRoute element={<VideoList />} />}
            />
            <Route
              path="/umpire"
              element={<ProtectedRoute element={<UmpireReport />} />}
            />
            <Route
              path="/ev-leaderboard"
              element={<ProtectedRoute element={<EVLeaderBoard />} />}
            />
            <Route
              path="/discipline-leaderboard"
              element={<ProtectedRoute element={<DisciplineLeaderBoard />} />}
            />
            <Route
              path="/game-report"
              element={<ProtectedRoute element={<InTimeGameReport />} />}
            />
            <Route
              path="/single-game-report/:type/:year/:game/:playerid"
              element={<ProtectedRoute element={<SingleGameReport />} />}
            />
            <Route
              path="/h2h-stat"
              element={<ProtectedRoute element={<HeadToHead />} />}
            />
            <Route
              path="/extra-report/:type"
              element={<ProtectedRoute element={<GeneralGameReport />} />}
            />
            <Route path="/login" element={<Login />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
            <Route
              path="/filmroom"
              element={<ProtectedRoute element={<Filmroom />} />}
            />
            {/*<Route path='/report' element={<PAReport />} />*/}
            {/*<Route path='/pitchreport' element={<PitchReport />} />*/}
            {/* Temperorily block all other routes for filter load test*/}
            {/*<Route path='/main' element={<MainPage />} />*/}
          </Routes>
        </Suspense>
      </div>
    </LocalizationProvider>
  );
};

export default App;
